__turbopack_context__.v({
  "main": "PaymentBtn-module-scss-module__x-SgpW__main",
});
